import React, { useState } from 'react';

interface QuestionFieldProps {
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
  placeholder?: string;
}

export const QuestionField: React.FC<QuestionFieldProps> = ({
  value,
  onChange,
  maxLength = 120,
  placeholder = "Optional: Ask your question for this reading..."
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const remainingChars = maxLength - value.length;

  return (
    <div className="w-full max-w-md mx-auto mb-4 relative z-30">
      {/* Input Field - no separate label */}
      <div className={`
        relative bg-black/20 backdrop-blur-sm rounded-lg border transition-colors
        ${isFocused ? 'border-purple-400/50' : 'border-purple-400/20'}
      `}>
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder={placeholder}
          maxLength={maxLength}
          rows={2}
          className="w-full p-3 bg-transparent text-white placeholder-white/50 resize-none focus:outline-none text-sm leading-tight"
          style={{ fontSize: '16px' }} // Prevent iOS zoom
        />
        
        {/* Character Counter */}
        <div className="absolute bottom-1 right-2">
          <span className={`text-xs ${
            remainingChars < 20 
              ? 'text-orange-400' 
              : remainingChars < 10 
                ? 'text-red-400' 
                : 'text-white/40'
          }`}>
            {remainingChars}
          </span>
        </div>
      </div>

      {/* Compact helper text */}
      <p className="text-xs text-white/40 mt-1 text-center">
        Saved with your reading for future reference
      </p>
    </div>
  );
};
